<script lang="ts">
  import { sendOtp, verifyOtp, DEFAULT_BASE_URL } from "./waves-api";
  import { WavesUserCancel } from "./exceptions";
  import type { Platform } from "./waves-api";

  export let baseUrl: string = DEFAULT_BASE_URL
  export let platform: Platform
  export let gameId: number

  export let email = ""
  let token = ""
  let otp = ""
  export let isOtpSent = false;
  export let isShowDialog = false;
  export let isSendingOtp = false;
  let isVerifyingOtp = false;
  let sendOtpError = ""
  let verifyOtpError = ""
  let onClose: () => void = () => {};

  export function getAuthToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      onClose = () => {
        if (token) {
          resolve(token);
        } else {
          reject(new WavesUserCancel());
        }
        onClose = () => {}
      };
      showDialog();
    });
  }

  function showDialog() {
    isShowDialog = true;
  }

  function closeDialog() {
    isShowDialog = false;
    isOtpSent = false;
    sendOtpError = "";
    verifyOtpError = "";
    onClose?.();
  }

  async function handleSendOtp() {
    if (isSendingOtp) return;
    sendOtpError = ""
    console.log("sendOtp", email);
    isSendingOtp = true;
    try {
      token = await sendOtp({
        baseUrl,
        platform,
        game_id: gameId,
        email,
      });
      console.log('token', token);
      if (token) {
        isOtpSent = true;
      }
      verifyOtpError = "";
    } catch(err) {
      console.error(err);
      if (err instanceof Error) {
        sendOtpError = err.message
      }
    } finally {
      isSendingOtp = false;
      // for mockup
      // isOtpSent = true;
    }
  }

  async function handleVerifyOtp() {
    if (isVerifyingOtp) return;
    verifyOtpError = ""
    console.log("verifyOtp", otp);
    isVerifyingOtp = true;
    try {
      await verifyOtp({
        baseUrl,
        platform,
        game_id: gameId,
        email,
        token,
        otp,
      });
      closeDialog();
      verifyOtpError = "";
    } catch (err) {
      console.error(err);
      if (err instanceof Error) {
        verifyOtpError = err.message
      }
    } finally {
      isVerifyingOtp = false;
      // for mockup
      // isShowDialog = false;
      // isOtpSent = false;
    }
  }
</script>

{#if isShowDialog}
  <div class="dialog-overlay">
    <div class="dialog vstack">
      <div class="dialog-title hstack">
        <div class="filler">Waves</div>
        <div><button type="button" on:click={closeDialog}>🗙</button></div>
      </div>
      <div class="dialog-body filler">
        {#if !isOtpSent}
          <form on:submit|preventDefault={handleSendOtp}>
            <div class="form-group">
              <label for="email">Email address</label>
              <input
                type="email"
                class="form-control"
                id="email"
                name="email"
                placeholder="someone@example.com"
                required
                bind:value={email}
              />
            </div>
            {#if sendOtpError}
              <div class="info" style="color: red;">{sendOtpError}</div>
            {/if}
            <div class="hstack">
              <button type="submit" class="btn btn-primary filler" disabled={isSendingOtp}
                >Send OTP</button
              >
            </div>
          </form>
        {:else}
          <div class="info">
            We are sending OTP to {email}. Please check your email inbox and enter the OTP.
          </div>
          <form on:submit|preventDefault={handleVerifyOtp}>
            <div class="form-group">
              <label for="otp">OTP</label>
              <input
                type="text"
                class="form-control"
                id="otp"
                name="otp"
                placeholder="Enter OTP"
                required
                bind:value={otp}
              />
            </div>
            {#if verifyOtpError}
              <div class="info" style="color: red;">{verifyOtpError}</div>
            {/if}
            <div class="hstack">
              <button type="button" class="btn filler" on:click={() => isOtpSent = false}>Resend OTP</button>
              <button type="submit" class="btn btn-primary filler" disabled={isVerifyingOtp}>Verify OTP</button>
            </div>
          </form>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  @font-face {
    font-family: 'Nintend';
    font-style: normal;
    font-weight: 400;
    src: url(../assets/NintendBoldRM8E.ttf) format('truetype');
  }

  .dialog-overlay {
    font-family: 'Nintend', 'ArcadeClassic', 'Courier New', Courier, monospace;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .info {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 14px;
    margin-bottom: 16px;
  }

  .dialog {
    width: 400px;
    min-height: 200px;
    background-color: rgb(255, 255, 255);
    border: rgb(46, 46, 46) 1px solid;
  }

  .dialog-title {
    background-color: rgb(14, 83, 139);
    color: white;
    padding-left: 8px;
    border-bottom: 1px solid rgb(46, 46, 46);
  }

  .dialog-title button {
    background-color: rgba(219, 199, 199, 0.5);
    border: none;
    color: rgb(70, 67, 67);
    font-size: 16px;
    padding: 4px;
    margin: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }

  .btn {
    border-radius: 8px;
    border: 3px solid transparent;
    padding: 0.6em 1.2em;
    font-size: 1em;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: border-color 0.25s;
  }
  .btn-primary {
    color: white;
    background-color: rgb(14, 83, 139);
  }
  .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .btn:hover {
    border-color: rgb(33, 164, 252);
    border-width: 3px;
  }
  .btn:focus,
  .btn:focus-visible {
    outline: 4px auto -webkit-focus-ring-color;
  }

  .filler {
    flex: 1;
  }

  .hstack {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .vstack {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .form-group {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
  }

  .form-control {
    height: 32px;
    padding: 4px;
    border: rgb(46, 46, 46) 1px solid;
  }

  .dialog-body {
    padding: 8px;
  }
</style>
